import { render, staticRenderFns } from "./QScoreCardQuilityRxCardsSent.vue?vue&type=template&id=74647bdc&scoped=true&"
import script from "./QScoreCardQuilityRxCardsSent.vue?vue&type=script&lang=js&"
export * from "./QScoreCardQuilityRxCardsSent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74647bdc",
  null
  
)

export default component.exports